<template>
    <ion-item :disabled="disabled" @click="openSelectModal()" lines="inset" class="ion-activatable ripple-parent">
        <ion-label position="stacked">{{ label }} </ion-label>
        <span style="text-overflow: ellipsis" class="my-2">{{ selected }}</span>
        <ion-icon size="small" color="primary" class="edit-icon" :icon="createOutline"></ion-icon>
        <ion-ripple-effect></ion-ripple-effect>
    </ion-item>

    <ion-modal :is-open="isOpen" @close="isOpen = false" :breakpoints="[0, 1]" :initialBreakpoint="1">
        <ion-header>
            <ion-toolbar color="white">
                <ion-buttons slot="start">
                    <ion-button color="primary" @click="cancel">
                        <mdicon name="close"></mdicon>
                    </ion-button>
                </ion-buttons>
                <ion-title>{{ label }}</ion-title>
                <ion-buttons v-if="showCreateButton" slot="end">
                    <ion-button color="primary" @click="createItem()">
                        <ion-icon slot="icon-only" :icon="add"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>

        <ion-content>
            <list @new="newComponent" :max_items="max_items" :inset="true" :field_name="field_id" :show_search="true"
                :items="items" @open="confirm" :item_size="50" :no_created_at="true" :truncate="false">

                <template v-slot:no-data>
                    <p class="no-data-title">Geen componenten gevonden</p>
                    <p class="no-data-subtitle">
                        Staat het apparaat dat je zoekt niet in de lijst? Vraag de beheerder om deze toe te voegen.
                    </p>
                </template>
            </list>
        </ion-content>
    </ion-modal>
</template>

<script>
import { createOutline } from 'ionicons/icons';
import list from './ComponentList.vue';

export default {
    name: 'novacheck-row',
    props: ['items', 'label', 'value', 'field_name', 'disabled', 'showCreateButton', 'fullscreen', 'location_item_uuid', 'max_items'],
    components: {
        list
    },
    emits: ['change', 'update:value', 'refresh'],
    data() {
        return {
            createOutline,
            current_selected: null,
            isOpen: false,

        }
    },
    methods: {
        async newComponent(component) {
            let url = '/components'
            await this.$requests.post('components', url, component, 'base_components').then(response => {
                this.confirm(component);
            }).catch(error => {
                this.$toast.error('Fout bij aanmaken component')
            })
        },
        reset() {
            this.current_selected = null
        },
        confirm(item) {
            this.current_selected = item

            this.isOpen = false
        },
        async openSelectModal() {
            this.isOpen = true
        },
        cancel() {
            this.isOpen = false
        },
    },
    computed: {
        selected() {
            if (this.current_selected) {
                return this.current_selected.name
            }

            return '-'
        }
    },
    watch: {
        value: {
            handler() {
                this.current_selected = this.value
            },
            immediate: true,
            deep: true
        },
        current_selected(newValue) {
            this.$emit('change', newValue);
            this.$emit('update:value', newValue)
        }
    }
}
</script>

<style>
.edit-icon {
    position: absolute;
    right: 15px;
    margin-top: 20px;
}
</style>
